/** A steady colour per team so a week with several teams is easy to scan. */
const HUES = [222, 160, 28, 280, 350, 190];

export function teamHue(teamId: string) {
  let h = 0;
  for (const c of teamId) h = (h * 31 + c.charCodeAt(0)) >>> 0;
  return HUES[h % HUES.length]!;
}

export function teamDotStyle(teamId: string) {
  return { backgroundColor: `hsl(${teamHue(teamId)} 55% 50%)` };
}
